import React from 'react';

const VSDivider = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="text-center space-y-4">
        {/* Top decorative line */}
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-gray-300 to-transparent mx-auto"></div>
        
        {/* VS Circle */}
        <div className="relative">
          <div className="w-16 h-16 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center shadow-lg border-4 border-white relative">
            {/* Inner shadow ring */}
            <div className="absolute inset-1 bg-gradient-to-br from-gray-600 to-gray-800 rounded-full"></div>
            
            {/* VS text */}
            <span className="text-white font-bold text-lg z-10 relative tracking-wider">VS</span>
          </div>
          
          {/* Corner accents */}
          <div className="absolute -top-1 -left-1 w-3 h-3 bg-blue-500 rounded-full opacity-80"></div>
          <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-orange-500 rounded-full opacity-80"></div>
        </div>
        
        {/* Competition Label */}
        <div className="space-y-1">
          <p className="text-sm font-bold text-gray-700 uppercase tracking-wide">Match</p>
          <div className="flex items-center justify-center space-x-1">
            <div className="w-3 h-px bg-gray-300"></div>
            <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
            <div className="w-3 h-px bg-gray-300"></div>
          </div>
        </div>
        
        {/* Bottom decorative line */}
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-gray-300 to-transparent mx-auto"></div>
      </div>
    </div>
  );
};

export default VSDivider; 